import { AssetTypeService } from './asset-type.service';
import { Injectable } from '@angular/core';
import { AlertController, NavController, LoadingController, ModalController } from '@ionic/angular';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { AlertService } from './alert.service';
import { ApiProjectService } from '../api-services/project.api.service';
import { Project } from '../models/Project';
import { ApiSceneService } from '../api-services/scene.api.service';
import { Scene } from '../models/Scene';
import { ApiSceneAssetRelationService } from './../api-services/scene-asset-relation.api.service';
import { ApiAssetService } from './../api-services/asset.api.service';
import { CopyService } from './copy.service';
import { ApiProjectOutcomeRelationService } from '../api-services/project-outcome-relation.api.service';
import { ProjectOutcomeRelation } from '../models/outcomes/ProjectOutcomeRelation';

@Injectable({
    providedIn: 'root'
})
export class ProjectOutcomeRelationService {

    constructor(
        public ProjectOutcomeRelationApi: ApiProjectOutcomeRelationService,
    ) {
    }

    async getProjectOutcomeRelationByProjectId(projectId) {
        let ProjectOutcomeRelation = [] as ProjectOutcomeRelation[];
        await new Promise<void>((resolve) => { 
            this.ProjectOutcomeRelationApi.getProjectOutcomeRelationByProjectId(projectId).subscribe(x=>{
                ProjectOutcomeRelation = x;
                resolve();
            }) 
        });
        return ProjectOutcomeRelation;
    }

    removeProjectOutcomeRelationByOutcomeAndProjectId(outcomeId, projectId){
        return this.ProjectOutcomeRelationApi.deleteProjectOutcomeRelation(outcomeId,projectId);
    }
}